<template>
  <div class="comment-list">
    <div class="comment-list__items">
      <BlockCommentRow
        v-for="(item,key) in list"
        :key="key"
        :comment="tdComment(item)"
      />
    </div>
    <BaseTag
      v-if="showLoadMore"
      color="transparent"
      custom-border="border border-primary"
      class="comment-list__action"
    >
      <BaseIcon
        v-if="!loading"
        class="transition"
        name="arrow_drop_down_circle"
        size="sm"
        :class="{'rotate-180': isFinished}"
      />
      <BaseButton
        :loading="loading"
        :label="$t('common.actions.show_more_review')"
        color="primary"
        light
        flat
        size="md"
        button-bg="bg-transparent"
        @click="loadMore"
      />
    </BaseTag>
  </div>
</template>

<script>
import BlockCommentRow from '@design-system/block/comment/comment-row'

export default {
  name: 'BlockCommentList',
  components: {
    BlockCommentRow
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    // this convertor is vital to convert key's data
    tdComment: {
      type: Function,
      default: () => [],
      required: true
    },
    showLoadMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFinished: false
    }
  },
  methods: {
    loadMore () {
      this.$emit('loadMore')
    }
  }
}
</script>

<style scoped lang="scss">
.comment-list {
  &__items {
    @apply divide-y divide-border-cart space-y-6;
  }
  &__action {
    @apply flex max-w-fit space-x-2 px-10 mx-auto mt-10 mb-36 py-0;
  }
}
</style>
